import React from 'react';
import Footer from "../../component-library/Footer_v01a_component";
import NavBar_v03Responsive from '../../component-library/NavBar_v03a_Responsive_component';
import { IAppConfig } from "../../App_v01_Interfaces";

interface AppConfigProps{
  appConfig: IAppConfig;
}

const TermsOfService_Page_vending_V01A_A2P: React.FC<AppConfigProps> = ({appConfig}) => {
  return (

    <>
    {/* <NavBar_v01 appConfig={appConfig}/> */}
    {/* <NavBar_v03Responsive appConfig={appConfig} /> */}

    <div className="container py-5">
      <h1 className="mb-4 text-center">Terms of Service</h1>

      <p className="text-muted">Last Updated: May 2, 2025</p>

      <section className="mb-4">
        <h4>1. Introduction</h4>
        <p>
          Welcome to our website. By accessing or using our services, you agree to comply with and be bound by the following terms and conditions. These terms apply to all visitors, users, and location partners who access or use our vending services.
        </p>
      </section>

      <section className="mb-4">
        <h4>2. Services Provided</h4>
        <p>
          We provide vending machine installation, maintenance, and product replenishment at qualifying locations. Machines may offer snacks, beverages, and other consumables. All services are subject to availability and eligibility.
        </p>
      </section>

      {/* A2P / Messaging Compliance (required if you collect/enable SMS) */}
      <section className="mb-4">
        <h4>3. SMS Messaging Terms &amp; Consent</h4>
        <p>
          If you provide your mobile phone number and opt in to receive SMS/text messages from us, you consent to receive text messages related to our services,
          including (as applicable) appointment confirmations, service updates, support responses, and marketing messages.
          Message frequency varies. Msg &amp; data rates may apply. Reply <strong>STOP</strong> to opt out at any time; reply <strong>HELP</strong> for help.
          Consent is not a condition of purchase.
        </p>
        <p>
          You represent that you are the account holder or have the account holder’s permission to enroll the provided number, and you agree to notify us if you change
          or deactivate the number.
        </p>
      </section>

      <section className="mb-4">
        <h4>4. Eligibility for Placement</h4>
        <p>
          Vending machines are installed at no cost for approved locations. We reserve the right to evaluate and accept or reject any placement request at our sole discretion.
        </p>
      </section>

      <section className="mb-4">
        <h4>5. Machine Maintenance</h4>
        <p>
          Our team is responsible for regular maintenance and restocking of vending machines. Any issues should be reported via our contact form or service line. We strive to respond to maintenance requests within 24–48 hours.
        </p>
      </section>

      <section className="mb-4">
        <h4>6. Refunds and Product Issues</h4>
        <p>
          If a machine malfunctions or a customer does not receive a purchased item, we offer a 100% satisfaction guarantee. Refunds can be requested online or by phone and will be processed promptly.
        </p>
      </section>

      <section className="mb-4">
        <h4>7. User Conduct</h4>
        <p>
          You agree not to misuse our website or services, attempt to harm or alter our machines, or interfere with other users’ access. We reserve the right to deny service or pursue legal action for abusive behavior.
        </p>
      </section>

      <section className="mb-4">
        <h4>8. Limitation of Liability</h4>
        <p>
          We are not liable for any damages resulting from the use or inability to use our machines or website. All services are provided “as is” without warranties of any kind, unless required by law.
        </p>
      </section>

      <section className="mb-4">
        <h4>9. Changes to Terms</h4>
        <p>
          We may update these Terms of Service at any time. Continued use of the site or our vending services after any such changes constitutes your acceptance of the new terms.
        </p>
      </section>

      <section className="mb-4">
        <h4>10. Contact Information</h4>
        <p>
          If you have questions about these terms, please contact us at <a href={`mailto:${appConfig.legalEMail}`}>{appConfig.legalEMail}</a>.
        </p>
      </section>
      

    </div>
    </>
  );
};

export default TermsOfService_Page_vending_V01A_A2P;